'use client';
import { useShowBotPaywall } from '../../hooks/useShowBotPaywall';

type Props = {
	recipientId: string;
};

export const BotPaywallContextRecipient = ({ recipientId }: Props) => {
	useShowBotPaywall({ recipientId });

	return null;
};
